import React, { useEffect, useState } from 'react';
import CustomModal from '../../components/modal';
import ImageGallery from '../../components/imageGallery';
import { themePropType } from '../../components/sharedPropTypes';
import { getImagePaths, loadImages } from '../../utils/imageLoader';

const BagCharmKeychains = ({theme}) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [charmsImages, setCharmsImages] = useState([]);
    const [keychainsImages, setKeychainsImages] = useState([]);
    
    useEffect(() => {
        const loadAllImages = async () => {
            // Load bag charms
            const bagCharms = await loadImages('bagCharms');
            setCharmsImages(bagCharms);
            
            // Load keychains
            const keychains = await loadImages('keychains');
            setKeychainsImages(keychains);
        };
        
        loadAllImages();
    }, []);

    return (
        <div className='bagCharmKeychainsPage'>
            <h3>Bag Charms and Keychains</h3>
            <p>I'm gonna count both keychains and bag charms on the same page since they basically serve the same function. I'll have two different image galleries though.</p>
            <p>The big strawberry (I call it strorberry) Yookie is more of a purse thing. But it's also blind box, so I'll also put it here anyway. </p>
            <h5>Bag Charms</h5>
            <ImageGallery
                images={charmsImages}
                onImageClick={setSelectedImage}
            />
            
            <h5>Keychains</h5>
            <ImageGallery
                images={keychainsImages}
                onImageClick={setSelectedImage}
            />
            
            <CustomModal
                isOpen={!!selectedImage}
                onRequestClose={() => setSelectedImage(null)}
                theme={theme}
            >
                {selectedImage && (
                <img 
                    src={selectedImage} 
                    style={{ maxWidth: '100%', maxHeight: '80vh' }} 
                    alt="Enlarged view" 
                />
                )}
            </CustomModal>
        </div>
    );
};

export default BagCharmKeychains;